import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { API_BASE_URL } from "../config";
import axiosInstance from "../config/axios";
import { handleApiError } from "../utils/handleApiError";
import GeneralLoader from "./common/GeneralLoader";
import LeaderboardItem from "./LeaderboardItem";
import SongCard from "./SongCard";
import SongModal from "./SongModal";
import useSongStore from "../store/song.store";

const LeaderboardScreen = () => {
  const [openModal, setOpenModal] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [isLoading2, setIsLoading2] = useState(false);
  const [answerLoading, setAnswerLoading] = useState(false);

  const [questions, setQuestions] = useState<any>();
  const [leaderboard, setLeaderboard] = useState<any>();

  const [modalDetails, setModalDetails] = useState<any>();

  const setSongDetails = useSongStore((state) => state.setSongDetails);

  const fetchQuestions = async () => {
    try {
      setIsLoading(true);
      const response: any = await axiosInstance.get(API_BASE_URL + "v1/survey/");
      setQuestions(response?.data);
    } catch (error) {
      handleApiError(error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchLeaderboard = async () => {
    try {
      setIsLoading2(true);
      const response: any = await axiosInstance.get(
        API_BASE_URL + "v1/stats/leaderboard/?subject=content&period=total"
      );
      setLeaderboard(response?.data);
    } catch (error) {
      handleApiError(error);
    } finally {
      setIsLoading2(false);
    }
  };

  const answerQuestion = async (answer: any) => {
    try {
      setAnswerLoading(true);

      const response = await axiosInstance.post(API_BASE_URL + "v1/survey/answer/", {
        question: questions?.question_data?.[0]?.id,
        answer: answer?.id,
      });

      setModalDetails({
        ...answer,
        percentage: response?.data?.answer_percentage?.percentage,
      });

      setOpenModal(true);

      setSongDetails(answer);
    } catch (error) {
      handleApiError(error);
    } finally {
      setAnswerLoading(false);
    }
  };

  useEffect(() => {
    fetchQuestions();
    fetchLeaderboard();
  }, []);

  return (
    <div
      className="w-full h-full flex flex-row text-black bg-repeat bg-cover bg-right"
      style={{
        backgroundImage: "url('/images/1.webp')",
      }}
    >
      {isLoading || isLoading2 ? (
        <GeneralLoader />
      ) : (
        <>
          {/* 👉 Right: Question + Song cards */}
          {questions ? (
            <div className="flex-[1_1_50%] min-w-0 h-full bg-[#f54f02] text-white flex flex-col justify-center items-center px-2 sm:px-6 text-center">
              <h1 className="text-base sm:text-xl md:text-2xl font-semibold sm:font-bold leading-relaxed px-3 mb-5 mt-2">
                {questions?.question_data?.[0]?.title}
              </h1>

              <div className="flex flex-col gap-6 w-full relative">
                <SongCard
                  cover={questions?.question_data?.[0]?.answers?.[0]?.track?.cover}
                  title={questions?.question_data?.[0]?.answers?.[0]?.title}
                  artist={
                    questions?.question_data?.[0]?.answers?.[0]?.track?.singer?.name
                  }
                  showTitleInTop={true}
                  onClick={() =>
                    answerQuestion(questions?.question_data?.[0]?.answers?.[0])
                  }
                />

                <div className="size-12 sm:size-16 p-1 sm:p-2 rounded-full absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-10 bg-black/20 backdrop-blur-md">
                  <motion.img
                    alt="arrows"
                    src="/images/arrows.svg"
                    className="size-full"
                    initial={{ rotate: 0 }}
                    animate={{ rotate: 1080 }}
                    transition={{ duration: 1.2, ease: "easeInOut" }}
                  />
                </div>

                <SongCard
                  cover={questions?.question_data?.[0]?.answers?.[1]?.track?.cover}
                  title={questions?.question_data?.[0]?.answers?.[1]?.title}
                  artist={
                    questions?.question_data?.[0]?.answers?.[1]?.track?.singer?.name
                  }
                  showTitleInTop={false}
                  onClick={() =>
                    answerQuestion(questions?.question_data?.[0]?.answers?.[1])
                  }
                />
              </div>
            </div>
          ) : null}

          {/* 👈 Left: Leaderboard */}

          <div className="flex-[1_1_50%] min-w-0 h-full bg-white/10 backdrop-blur-sm overflow-y-auto pb-20">
            <img
              src="/images/leaderboard-crown.svg"
              alt="leaderboard-crown"
              className="w-full mb-6"
            />

            {leaderboard && leaderboard?.leaderboard?.length > 0 ? (
              <div className="space-y-4 px-2">
                {leaderboard?.leaderboard?.map((item: any) => (
                  <LeaderboardItem key={item.id} {...item} />
                ))}
              </div>
            ) : (
              <p className="px-5 mt-10 text-lg text-center font-semibold">
                {/* در حال حاضر داده ای برای نمایش وجود ندارد */}
                هنوز پیشوازی تو رتبه بندی نیومده!
              </p>
            )}
          </div>

          {openModal ? (
            <SongModal
              artist={modalDetails?.track?.singer?.name}
              cover={modalDetails?.track?.cover}
              title={modalDetails?.track?.name}
              percentage={modalDetails?.percentage}
              onClose={() => setOpenModal(false)}
            />
          ) : null}
        </>
      )}
    </div>
  );
};

export default LeaderboardScreen;
